<template>
  <page-view class="subpage" :key="$route.hash" :title="`${log.method} ${log.path}`" :backLink="backLink" backText="Back to Logs" v-if="log">
    <card-minimal title="Summary">
      <div class="p-a-4">
        <p class="card-content-title">ID</p>
        <p>{{ log.id }}</p>
        <p class="card-content-title m-t-2">Time</p>
        <p>{{ log.time | formatdate('YYYY-MM-DD HH:mm:ss') }}</p>
        <p class="card-content-title m-t-2">Method</p>
        <p>{{ log.method }}</p>
        <p class="card-content-title m-t-2">URL</p>
        <p>{{ log.path }}</p>
        <p class="card-content-title m-t-2">Status</p>
        <p :class="{'ok': log.status >= 200 && log.status < 300, 'err': log.status >= 300 && log.status < 400, 'fatal': log.status >= 400}">{{ log.status }}</p>
        <p class="card-content-title m-t-2">User</p>
        <p>{{ log.user }}</p>
      </div>
    </card-minimal>
    <card-minimal title="Request Parameters" class="m-t-4" v-if="log.request_params">
      <pre v-html="formatJSON(log.request_params)"></pre>
    </card-minimal>
    <card-minimal title="Request Body" class="m-t-4" v-if="log.request_body">
      <pre v-html="formatJSON(log.request_body)"></pre>
    </card-minimal>
    <card-minimal title="Response" class="m-t-4" v-if="log.response_body">
      <pre v-html="formatJSON(log.response_body)"></pre>
    </card-minimal>
  </page-view>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  methods: {
    /**
     * Get log
     * @returns {Void}
     */
    async getLog() {
      const log = await this.$store.dispatch('Developer/log', this.id);

      if (!log) {
        // could not fetch, what to do?
        return;
      }

      this.log = log;
    },
    /**
     * Try and parse JSON to determain if JSON or not
     * @param {String} json
     * @returns {Boolean}
     */
    isJSON(json) {
      try {
        JSON.parse(json);
        return true;
      } catch (e) {
        return false;
      }
    },
    /**
     * Format JSON and fall back to just returning as text if not json
     * @param {String} data
     * @returns {String}
     */
    formatJSON(data) {
      try {
        if (this.isJSON(data)) {
          return JSON.stringify(JSON.parse(data), null, 6).replace(/\n( *)/g, (match, p1) => `<br>${'&nbsp;'.repeat(p1.length)}`);
        }
        return JSON.stringify(JSON.parse(`{"${decodeURI(data.replace(/&/g, '","').replace(/=/g, '":"'))}"}`), null, 6).replace(/\n( *)/g, (match, p1) => `<br>${'&nbsp;'.repeat(p1.length)}`);
      } catch (e) {
        return data;
      }
    },
  },
  data() {
    return {
      backLink: '/developer/logs',
      log: null,
    };
  },
  mounted() {
    const lastRoute = this.$store.getters['Theme/lastRoute'];
    if (lastRoute && lastRoute.path.includes('logs')) {
      this.backLink = lastRoute.fullPath;
    }
    this.getLog();
  },
};
</script>

<style lang="scss" scoped>
@import '../../variables.sass';

.ok {
  color: $successColor;
}

.err {
  color: $warningColor;
}

.fatal {
  color: $alertColor;
}

pre {
  margin-top: 0;
  overflow: auto;
  padding: 15px;
}
</style>
